(function () {
  if (window.MapclubApi && window.MapclubApi.ready) return;

  var config = window.mapclubApiConfig || {};
  var mapclubProxyPath = config.proxyPath || "apps/mapclub-production";
  var brokenMapclubProxyPattern = /^\/idapps(?=\/mapclub-production(?:\/|$))/i;

  function normalizeLocaleRoot(path) {
    if (typeof path !== "string" || !path.length) return "/";
    if (path === "/") return path;
    return path.endsWith("/") ? path : path + "/";
  }

  function normalizeLocaleAppProxyPath(input) {
    if (!input) return input;

    try {
      var isString = typeof input === "string";
      var rawValue = isString ? input : input.toString();
      var url = new URL(rawValue, window.location.origin);
      var normalizedPath = url.pathname.replace(
        brokenMapclubProxyPattern,
        "/id/apps",
      );

      if (normalizedPath === url.pathname) return input;

      url.pathname = normalizedPath;

      if (!isString) return url;

      return /^(https?:)?\/\//i.test(rawValue)
        ? url.toString()
        : url.pathname + url.search + url.hash;
    } catch (error) {
      return input;
    }
  }

  function getLocaleRoot() {
    var shopifyRoot =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return normalizeLocaleRoot(shopifyRoot || config.rootUrl || "/");
  }

  function buildMapclubUrl(endpoint) {
    var cleanEndpoint = String(endpoint || "").trim().replace(/^\/+/, "");
    cleanEndpoint = cleanEndpoint.replace(/^apps\/mapclub-production\/?/, "");

    var url = getLocaleRoot() + mapclubProxyPath;
    if (cleanEndpoint) url += "/" + cleanEndpoint;

    return normalizeLocaleAppProxyPath(url);
  }

  function fetchMapclub(endpoint, options) {
    return window.fetch(buildMapclubUrl(endpoint), options);
  }

  var originalFetch = window.fetch;
  if (typeof originalFetch === "function") {
    window.fetch = function (resource, init) {
      if (typeof resource === "string" || resource instanceof URL) {
        resource = normalizeLocaleAppProxyPath(resource);
      } else if (window.Request && resource instanceof Request) {
        var normalizedRequestUrl = normalizeLocaleAppProxyPath(resource.url);
        if (normalizedRequestUrl !== resource.url) {
          resource = new Request(normalizedRequestUrl, resource);
        }
      }

      return originalFetch.call(this, resource, init);
    };
  }

  var originalXhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    var normalizedUrl =
      typeof url === "string" || url instanceof URL
        ? normalizeLocaleAppProxyPath(url)
        : url;
    return originalXhrOpen.apply(
      this,
      [method, normalizedUrl].concat(Array.prototype.slice.call(arguments, 2)),
    );
  };

  window.__normalizeLocaleRoot = normalizeLocaleRoot;
  window.__normalizeLocaleAppProxyPath = normalizeLocaleAppProxyPath;
  window.mapclubUrl = buildMapclubUrl;
  window.mapclubFetch = fetchMapclub;
  window.MapclubApi = {
    fetch: fetchMapclub,
    proxyPath: mapclubProxyPath,
    ready: true,
    url: buildMapclubUrl,
  };
})();
